<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="profile && profile.tank_manufacturers_specs ? profile.tank_manufacturers_specs : []"
            :loading="table_loader"
            hide-actions
        >
            <template slot="items" slot-scope="props">
                <tr class="clickable" @mouseup.left="showTankManufacturersSpec(props.item)">
                    <td><img :src="props.item.image_url" @error="imageLoadError" class="img-table" style="max-width: 75px" /></td>
                    <td>{{ props.item.tank_name }}</td>
                    <td>{{ props.item.tank_type_id }}</td>
                    <td class="text-center">{{ props.item.def_us_gallons || "---" }}</td>
                    <td class="text-center">{{ props.item.metric_diameter || "---" }}</td>
                    <td class="text-center">{{ props.item.metric_height || "---" }}</td>
                    <td class="text-center">{{ props.item.metric_width || "---" }}</td>
                    <td class="text-center">{{ props.item.metric_length || "---" }}</td>
                </tr>
            </template>
            <template slot="no-data">
                <tr class="no-hover">
                    <td class="w-100" :colspan="headers.length">
                        <v-layout>
                            <v-flex class="text-center align-content-center" style="height: calc(100vh - 300px)">
                                <span class="blue-grey--text text--lighten-4 display-1">{{ table_loader ? $t("lang.loading") : $t("lang.no_specs") }}</span>
                            </v-flex>
                        </v-layout>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <bc-dialog :value="tank_manufacturers_spec_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ currObjField("tank_spec_id") ? $t("lang.edit_spec") : $t("lang.add_spec") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closeTankManufacturersSpecDialog"
                        :dialog-status="tank_manufacturers_spec_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="tank_manufacturers_spec">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <!-- <v-flex xs12>
										<bc-autocomplete
											:focus="tank_manufacturers_spec_dialog"
											v-model="tank_manufacturers_spec.manufacturer_id"
											:label="$t('lang.manufacturer_id')"
											:items="manufacturer_id"
											item-value="value"
											item-text="text"
											:rules="ifValid('tank_manufacturers_spec.manufacturer_id')"
										></bc-autocomplete>
									</v-flex> -->
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="tank_manufacturers_spec.tank_name"
                                        :label="`${$t('lang.tank_name')} *`"
                                        :counter="showCounter(tank_manufacturers_spec.tank_name, 'tank_manufacturers_spec.tank_name')"
                                        :rules="ifValid('tank_manufacturers_spec.tank_name')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="tank_manufacturers_spec.tank_type_id"
                                        :label="`${$t('lang.tank_type_id')} *`"
                                        :items="tank_types"
                                        item-value="tank_type_id"
                                        item-text="tank_type"
                                        :rules="ifValid('tank_manufacturers_spec.tank_type_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="tank_manufacturers_spec.def_us_gallons"
                                        :label="`${$t('lang.def_us_gallons')} *`"
                                        :counter="showCounter(tank_manufacturers_spec.def_us_gallons, 'tank_manufacturers_spec.def_us_gallons')"
                                        :rules="ifValid('tank_manufacturers_spec.def_us_gallons')"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="tank_manufacturers_spec.metric_diameter"
                                        :label="$t('lang.metric_diameter')"
                                        :counter="showCounter(tank_manufacturers_spec.metric_diameter, 'tank_manufacturers_spec.metric_diameter')"
                                        :rules="ifValid('tank_manufacturers_spec.metric_diameter')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="tank_manufacturers_spec.metric_height"
                                        :label="$t('lang.metric_height')"
                                        :counter="showCounter(tank_manufacturers_spec.metric_height, 'tank_manufacturers_spec.metric_height')"
                                        :rules="ifValid('tank_manufacturers_spec.metric_height')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="tank_manufacturers_spec.metric_width"
                                        :label="$t('lang.metric_width')"
                                        :counter="showCounter(tank_manufacturers_spec.metric_width, 'tank_manufacturers_spec.metric_width')"
                                        :rules="ifValid('tank_manufacturers_spec.metric_width')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="tank_manufacturers_spec.metric_length"
                                        :label="$t('lang.metric_length')"
                                        :counter="showCounter(tank_manufacturers_spec.metric_length, 'tank_manufacturers_spec.metric_length')"
                                        :rules="ifValid('tank_manufacturers_spec.metric_length')"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="currObjField('tank_spec_id')" color="error" @mouseup.left="$refs.delete_tank_manufacturers_spec.openDialog()">{{
                        $t("lang.delete")
                    }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeTankManufacturersSpecDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        color="success"
                        @mouseup.left="modifyTankManufacturersSpec(currObjField('tank_spec_id') ? 'patch' : 'post', currObjField('tank_spec_id'))"
                        >{{ $t("lang.save") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_tank_manufacturers_spec"
            :heading="$t('lang.delete_tank_manufacturers_spec')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="modifyTankManufacturersSpec('delete', currObjField('tank_spec_id'))"
        ></delete-confirmation-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.name"), value: "name" },
                { text: this.$t("lang.email_address"), value: "primary_email_address" },
                { text: this.$t("lang.has_user_account"), value: "has_user_account", align: "center" },
            ],
            headers: [
                // { text: this.$t('lang.manufacturer_id'), sortable: false, width: '12%' },
                { text: "", sortable: false, align: "center", width: "60" },
                { text: this.$t("lang.tank_name"), sortable: false },
                { text: this.$t("lang.tank_type_id"), sortable: false },
                { text: this.$t("lang.def_us_gallons"), sortable: false, align: "center" },
                { text: this.$t("lang.metric_diameter"), sortable: false, align: "center" },
                { text: this.$t("lang.metric_height"), sortable: false, align: "center" },
                { text: this.$t("lang.metric_width"), sortable: false, align: "center" },
                { text: this.$t("lang.metric_length"), sortable: false, align: "center" },
            ],
            tank_manufacturers_spec: {
                manufacturer_id: "",
                tank_name: "",
                tank_type_id: "",
                def_us_gallons: "",
                metric_diameter: "",
                metric_height: "",
                metric_width: "",
                metric_length: "",
            },
            current_obj: null,
            table_loader: false,
            tank_manufacturers_spec_dialog: false,
        };
    },
    computed: {
        ...mapState({
            rules_tank_manufacturers_spec: (state) => state.validation.rules_tank_manufacturers_spec,
            profile: (state) => state.tank_manufacturers.tank_manufacturer,
            tank_types: (state) => state.tank_types.tank_types,
        }),
        axiosParams() {
            const params = new URLSearchParams();
            params.append("manufacturer_id", this.$route.params.id);
            return params;
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        closeTankManufacturersSpecDialog() {
            this.tank_manufacturers_spec_dialog = false;
            this.$refs.delete_tank_manufacturers_spec.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        modifyTankManufacturersSpec(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("tank_manufacturers_spec")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchTankManufacturer", {
                                pk: "tank_spec_id",
                                id: id,
                                url: `tank_manufacturers/${this.$route.params.id}/specifications/${id ? id : ""}`,
                                method: method,
                                stateProperty: "tank_manufacturer.tank_manufacturers_specs",
                                dataProperty: "tank_manufacturers_specs",
                                mutate: true,
                                body: this.tank_manufacturers_spec,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeTankManufacturersSpecDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showTankManufacturersSpec(item = null) {
            this.current_obj = item;
            if (this.tank_types == null) this.getTankTypes();

            if (this.$refs.tank_manufacturers_spec) item ? this.$refs.tank_manufacturers_spec.resetValidation() : this.$refs.tank_manufacturers_spec.reset();

            this.$nextTick(() => {
                this.assignObj(this.tank_manufacturers_spec, item, this.rules_tank_manufacturers_spec);
                this.tank_manufacturers_spec_dialog = true;
            });
        },
        getTankTypes() {
            this.$store.dispatch("fetchTankType", {
                url: "tank_types",
                method: "get",
                stateProperty: "tank_types",
                commit: true,
            });
        },
        imageLoadError(e) {
            e.target.src = "https://via.placeholder.com/50";
        },
    },
};
</script>
